import React, { useContext, useRef } from "react";
import { AuthFunctionsContext } from "State/AuthFunctionsContext";
import ReCaptchaComponent from "Components/Common/ReCaptchaComponent";
import SbInput from "uiCore/SbInput/SbInput";
import SbButton from "uiCore/SbButton/SbButton";
import {
  FormStyled,
  FieldStyled,
  LabelStyled,
  LinksRowStyled,
  LinkStyled,
  MessageStyled,
} from "Pages/SbAuthPage/LoginV2.styles";

// Renders only the forgot-password form(s) — the layout is provided by LoginPageLayout.
const SbForgotPasswordComponent = () => {
  const {
    username,
    setUsername,
    otp,
    setOtp,
    password,
    setPassword,
    confirmPassword,
    setConfirmPassword,
    error,
    sb_auth_forgotPasswordStep1,
    sb_auth_forgotPasswordStep2,
    sb_auth_forgotPasswordStep3,
    loadingAuth,
    toggleForgotPassword,
    sb_auth_handleBlur,
    forgotPasswordStep,
    otpValid,
    sb_auth_reSendOtpForgot,
    captchaToken,
    setCaptchaToken,
  } = useContext(AuthFunctionsContext);

  const recaptchaRef = useRef(null);
  const isRecaptchaEnabled = process.env.REACT_APP_RECAPTCHA_ENABLED !== "false";
  const handleCaptchaChange = (token) => setCaptchaToken(token);

  const handleEmailSubmit = async () => {
    await sb_auth_forgotPasswordStep1(username, recaptchaRef);
  };
  const handleVerifyOtpSubmit = async () => {
    await sb_auth_forgotPasswordStep2(username, otp);
  };
  const handleResetPasswordSubmit = () => {
    sb_auth_forgotPasswordStep3(username, password, confirmPassword);
  };
  const handleResendOtpClick = (e) => {
    e.preventDefault();
    sb_auth_reSendOtpForgot(username);
  };

  if (forgotPasswordStep === 1) {
    return (
      <FormStyled onFinish={handleEmailSubmit}>
        <FieldStyled>
          <LabelStyled htmlFor="email">Business Email</LabelStyled>
          <SbInput
            id="email"
            type="email"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            onBlur={sb_auth_handleBlur}
            required
          />
          {error.username && <MessageStyled>{error.username}</MessageStyled>}
        </FieldStyled>

        <ReCaptchaComponent ref={recaptchaRef} onChange={handleCaptchaChange} theme="dark" />
        {error.captcha && <MessageStyled>{error.captcha}</MessageStyled>}
        {error.authfail && (
          <MessageStyled dangerouslySetInnerHTML={{ __html: error.authfail }} />
        )}

        <SbButton
          buttonType="accent"
          htmlType="submit"
          loading={loadingAuth}
          disabled={isRecaptchaEnabled && !captchaToken}
        >
          Send OTP
        </SbButton>

        <LinksRowStyled>
          <span>
            Remember your password?{" "}
            <LinkStyled onClick={toggleForgotPassword}>Back to Login</LinkStyled>
          </span>
        </LinksRowStyled>
      </FormStyled>
    );
  }

  if (forgotPasswordStep === 2) {
    return (
      <FormStyled onFinish={handleVerifyOtpSubmit}>
        <MessageStyled $success>
          {otpValid ||
            "If your email is registered with us, you'll receive an OTP. Check your spam folder if it doesn't arrive."}
        </MessageStyled>

        <FieldStyled>
          <LabelStyled htmlFor="otp">Enter OTP</LabelStyled>
          <SbInput
            id="otp"
            type="tel"
            inputMode="numeric"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            onBlur={sb_auth_handleBlur}
            maxLength={6}
            required
          />
          {error.otp && <MessageStyled>{error.otp}</MessageStyled>}
        </FieldStyled>

        {error.authfail && (
          <MessageStyled dangerouslySetInnerHTML={{ __html: error.authfail }} />
        )}

        <SbButton buttonType="accent" htmlType="submit" loading={loadingAuth}>
          Validate OTP
        </SbButton>

        <LinksRowStyled>
          <LinkStyled onClick={handleResendOtpClick}>Resend OTP</LinkStyled>
          <LinkStyled onClick={toggleForgotPassword}>Back to Login</LinkStyled>
        </LinksRowStyled>
      </FormStyled>
    );
  }

  return (
    <FormStyled onFinish={handleResetPasswordSubmit}>
      <FieldStyled>
        <LabelStyled htmlFor="password">New Password</LabelStyled>
        <SbInput
          id="password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onBlur={sb_auth_handleBlur}
          required
        />
        {error.password && <MessageStyled>{error.password}</MessageStyled>}
      </FieldStyled>

      <FieldStyled>
        <LabelStyled htmlFor="confirmPassword">Confirm New Password</LabelStyled>
        <SbInput
          id="confirmPassword"
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          onBlur={sb_auth_handleBlur}
          required
        />
        {error.confirmPassword && <MessageStyled>{error.confirmPassword}</MessageStyled>}
      </FieldStyled>

      {error.authfail && (
        <MessageStyled dangerouslySetInnerHTML={{ __html: error.authfail }} />
      )}

      <SbButton buttonType="accent" htmlType="submit" loading={loadingAuth}>
        Reset Password
      </SbButton>

      <LinksRowStyled>
        <span>
          Remember your password?{" "}
          <LinkStyled onClick={toggleForgotPassword}>Back to Login</LinkStyled>
        </span>
      </LinksRowStyled>
    </FormStyled>
  );
};

export default SbForgotPasswordComponent;
